<template>
  <Head title="Login" />
  <div class="min-h-screen bg-primary grid grid-cols-1 md:grid-cols-2">
    <div class="flex items-center justify-center">
      <img src="/images/logo_home.png" width="346" height="135">
    </div>
    <div class="flex items-center justify-center bg-white rounded-t-lg md:rounded-none md:rounded-l-lg min-h-full">
      <form class="mt-1 w-full max-w-lg" @submit.prevent="login">
        <div class="py-12 px-10">
          <img class="mb-8 hidden md:block" src="/images/logo_auth.png" width="100" height="100">
          <h1 class="text-3xl">Painel do Administrador</h1>
          <email-input v-model="form.email" :error="form.errors.email" class="mt-10" label="E-mail" type="email" autofocus autocapitalize="off" />
          <password-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Senha" />
          <loading-button :loading="form.processing" class="btn-primary w-full mt-6 justify-center" type="submit">Login</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/Fields/TextInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import LoadingButton from '@/Shared/Components/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
    EmailInput,
    PasswordInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: process.env.NODE_ENV !== 'production' ? 'admin@ahlife.com.br' : '',
        password: process.env.NODE_ENV !== 'production' ? '123456' : '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/admin/login')
    },
  },
}
</script>
